import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import styles from './index.css'

@withRouter
export default class SelectField extends React.Component {
  
  static propTypes = {
    value : PropTypes.string,
    onChange : PropTypes.func,
    label : PropTypes.string,
    disabled : PropTypes.bool
  }

  static defaultProps = {
    fullWidth : true,
    disabled : false
  }

  constructor(props) {
    super(props)
  }

  render() {
    let classes = [styles.SelectField]
    if (this.props.fullWidth) {
      classes.push(styles.fullWidth)
    }
    const { meta } = this.props
    let errorText = null
    if (meta) {
      if (typeof meta.error === 'string') {
        classes.push(styles.error)
        errorText = meta.error
      }
    }
    return [
      <label key={0} className={styles.Label}>
        {this.props.label||''}
      </label>
      ,
      <div key={1} className={this.props.fullWidth ? styles.fullWidth: ''}>
        <select 
          disabled={this.props.disabled}
          className={classes.join(' ')}
          value={this.props.value || (this.props.input && this.props.input.value)}
          onChange={event => {
            if (this.props.onChange) {
              this.props.onChange(event.target.value)
            }
            if (this.props.input) {
              this.props.input.onChange(event.target.value)
            }
          }}
        >
        {this.props.children}
      </select>
        { 
          errorText &&
            <div key={3} className={styles.ErrorText}>{errorText}</div>
        }
      </div>
    ]
  }

}



// WEBPACK FOOTER //
// ./src/components/SelectField/index.jsx